import React, {
  useCallback, useState, useRef, useEffect,
} from 'react';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import clsx from 'clsx';

import { StudioControlStyles } from '../styles';
import {
  selectIsConnectingAudioService,
  selectIsCountdown,
} from '../../../store/modules/studio/selectors';
import StudioToolTip from "./StudioToolTip";

const AudioLevel = () => {
  const classes = StudioControlStyles();
  const refCanvas = useRef<HTMLCanvasElement>(null);
  const isConnectingAudioService = useSelector(selectIsConnectingAudioService);
  const isCountdown = useSelector(selectIsCountdown);

  // Enable a debug view of the audio data
  const [debug, setDebug] = useState<boolean>(false);

  useEffect(() => {
    if (refCanvas.current !== null && window.studioAudioService !== undefined && isConnectingAudioService) {
      window.studioAudioService.setCanvas(refCanvas.current);
    }
  }, [refCanvas, isConnectingAudioService]);

  const toggleDebug = useCallback(() => {
    const newDebug = !debug;
    setDebug(newDebug);
    if (window.studioAudioService !== undefined) {
      window.studioAudioService.setDebug(newDebug);
    }
  }, [debug, setDebug]);

  return (
    <StudioToolTip title={'Indicator of the audio sound level'}>
      <Grid item>
        <div hidden={!isConnectingAudioService || isCountdown}>
          <p className={classes.label}>Audio Level</p>
          <canvas
            onClick={toggleDebug}
            ref={refCanvas}
            className={clsx(classes.audioMeter, debug ? classes.audioMeterDebug : '')}
          />
        </div>
      </Grid>
    </StudioToolTip>
  );
};

export default AudioLevel;
